import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Inputbox from '../Common/Inputbox';
import TextareaBox from '../Common/TextareaBox';
import Formvalidation from "../Validation/Formvalidation";
import { addComplaintapi } from "../../redux/formslice"; // assume you have or will create this
import BreadComp from './BreadComp';
import { MediaQueries } from "../../components/utils";
import { addComplaint } from '../../services/Apis';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
const PlacecomplaintForm = () => {
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);

    const { isMobile } = MediaQueries();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        orderid: "",
        email: "",
        mobile: "",
        comments: ""
    });

    const [errors, setErrors] = useState({});

    const isFormValid = () => {
        const validEmail = /^\S+@\S+\.\S+$/.test(formData.email);
        const validMobile = new RegExp(`^\\d{${currentcountry.isAreaCodeRequired ? 9 : currentcountry.number_count}}$`).test(formData.mobile);

        return (
            formData.orderid &&
            validEmail &&
            validMobile &&
            formData.comments.trim() !== ""
        );
    };

    const handleNext = async () => {
        if (!isFormValid()) return;

        const input_data = {
            mobile: formData.mobile,
            invoice: formData.orderid,
            email: formData.email,
            comment: formData.comments
        };

      var response = await addComplaint(input_data);

      if(response.data.success == false){
        toast.error('Invalid Order Id / email', {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
      }else{
        navigate('/success-complaints')
      }
    };

    // OMRSSOP3236

    const { handleChange, handleSubmit } = Formvalidation(
        formData,
        setFormData,
        setErrors,
        handleNext
    );

    return (
        <div className=' mt-2 '>


            <div className={`${isMobile ? "" : 'mytractrightside'}`}>
                <Inputbox
                    id="orderid"
                    type="text"
                    value={formData.orderid}
                    handleChange={handleChange}
                    placeholder="Enter Order Id"
                    title="Order id"
                    error={errors.orderid}
                />

                <Inputbox
                    id="mobile"
                    type="text"
                    value={formData.mobile}
                    name={'mobile'}
                    handleChange={handleChange}
                    placeholder="Enter your mobile number"
                    title="Mobile"
                    error={errors.mobile}
                />

                <Inputbox
                    id="email"
                    type="email"
                    value={formData.email}
                    handleChange={handleChange}
                    placeholder="Enter your email"
                    title="Email"
                    error={errors.email}
                />

                <TextareaBox
                    id="comments"
                    label="Comments"
                    placeholder="Write down your complaint."
                    value={formData.comments}
                    onChange={(e) =>
                        setFormData({ ...formData, comments: e.target.value })
                    }
                    error={errors.comments}
                />
            </div>

            <div className="d-flex justify-content-end">
                <div
                    className={isFormValid() ? "activeformsubmitbutton profileviewsubmitbtn" : "formsubmitbutton profileviewsubmitbtn"}
                    onClick={isFormValid() ? handleSubmit : null}
                >
                    Submit
                </div>
            </div>
        </div>
    );
};

export default PlacecomplaintForm;
